export default __webpack_public_path__ + "static/media/6N5A3880_tn.102007d6.jpg";